import { DatePicker } from "@mui/x-date-pickers-pro";
import { formatISO, isValid, parseISO } from "date-fns";

interface Props {
  commitmentDate: string | undefined;
  validationError?: string;
  disabled?: boolean;
  onDateChanged: (date: string | undefined) => void;
}

const CommitmentDatePicker = ({ commitmentDate, onDateChanged, validationError, disabled }: Props) => {
  const dateValue = commitmentDate ? parseISO(commitmentDate) : null;

  return (
    <DatePicker
      label="Commitment Date"
      value={dateValue}
      onChange={(date, ctx) => {
        onDateChanged(
          ctx.validationError || !date || !isValid(date) ? undefined : formatISO(date, { representation: "date" })
        );
      }}
      slotProps={{
        textField: {
          error: !!validationError,
        },
      }}
      disabled={disabled}
    />
  );
};

export default CommitmentDatePicker;
